/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_6_ProblemInputs */

const et_portfolio_project_6_problem = /** @type {(inputs: Portfolio_Project_6_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aegunud veebileht, mis ei peegeldanud ekspertiisi ega muutnud külastajaid päringuteks.`)
};

const en_portfolio_project_6_problem = /** @type {(inputs: Portfolio_Project_6_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outdated website that didn’t reflect expertise or convert visitors into leads.`)
};

/**
* | output |
* | --- |
* | "Outdated website that didn’t reflect expertise or convert visitors into leads." |
*
* @param {Portfolio_Project_6_ProblemInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_6_problem = /** @type {((inputs?: Portfolio_Project_6_ProblemInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_6_ProblemInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_6_problem(inputs)
	return en_portfolio_project_6_problem(inputs)
});